import { DocsBlockPropertyDefinition, } from "./SDKDocsBlockProperty";
/** Component property - Definition */
export class DocsBlockComponentPropertyDefinition extends DocsBlockPropertyDefinition {
}
